<template>
  <main>
    <section
      id="intro"
      class="main-row"
    >
      <b-container>
        <b-row>
          <b-col
            md="7"
            lg="6"
          >
            <h1 v-html="$t('meta.title')"></h1>
            <h2 v-html="$t('meta.lead')"></h2>
            <p class="actions">
              <a
                class="btn btn-lg btn-primary"
                :href="$t('actions.createPetition.link')"
              >
                {{ $t('actions.createPetition.label') }}
              </a>
            </p>
            <div class="pt-5 pt-sm-5 pt-md-0 mb-5">
              <form
                action="/petition/search"
                method="GET"
              >
                <div
                  class="input-group"
                >
                  <div class="input-group-prepend">
                    <div class="input-group-text d-none d-sm-flex">
                      <i class="fas fa-magnifying-glass text-muted mr-1"></i>
                    </div>
                  </div>
                  <input
                    id="q"
                    name="q"
                    type="text"
                    class="form-control form-control-lg"
                    maxlength="50"
                    :aria-label="$t('actions.search.label')"
                    aria-describedby="button-submit-search-petitions"
                    :placeholder="$t('actions.search.label')"
                    required="true"
                    minlength="3"
                  />
                  <div class="input-group-append">
                    <button
                      id="button-submit-search-petitions"
                      type="submit"
                      class="btn btn-light h-100 border-0 btn-lg btn-block"
                    >
                      {{ $t('actions.search.button') }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </b-col>
        </b-row>
        <b-row
          id="learn-more"
          aria-hidden="true"
          align-h="center"
          class="d-none d-sm-flex"
        >
          <input
            id="btn-learn-more"
            type="checkbox"
            class="sr-only"
            @change="$refs['what']
              .scrollIntoView({ behavior: 'smooth' })"
          />
          <label
            for="btn-learn-more"
            class="btn btn-sm btn-link p-0"
          >
            <span>En savoir plus</span>
            <i class="fas fa-lg fa-chevron-down d-block fc-g8"></i>
          </label>
        </b-row>
      </b-container>
    </section>

    <section
      id="what"
      ref="what"
    >
      <b-container>
        <b-row>
          <b-col>
            <h2 class="sr-only">
              {{ $t('what.title') }}
            </h2>
            <b-tabs
              align="center"
              card
              pills
            >
              <b-tab
                active
                class="p-0"
                :title="$t('what.tab1.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/simplicite.png`" />
                  </b-col>
                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab1.desc')"
                  />
                </b-row>
              </b-tab>
              <b-tab
                class="p-0"
                :title="$t('what.tab2.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                    order-md="2"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/vieprivee.png`" />
                  </b-col>

                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab2.desc')"
                  />
                </b-row>
              </b-tab>
              <b-tab
                class="p-0"
                :title="$t('what.tab3.label')"
              >
                <b-row>
                  <b-col
                    md="6"
                    lg="7"
                  >
                    <web-screen :img="`${$t('baseurl')}img/screens/analyse.png`" />
                  </b-col>

                  <b-col
                    class="px-3"
                    md="6"
                    lg="5"
                    v-html="$t('what.tab3.desc')"
                  />
                </b-row>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-container>

    </section>

    <how />

    <why />

    <who />

    <sfs />

    <outro />
  </main>
</template>

<script>
import WebScreen from '../../commons/components/WebScreen.vue';
import How from '../../commons/components/hos/How.vue';
import Why from '../../commons/components/hos/Why.vue';
import Who from '../../commons/components/hos/Who.vue';
import Outro from '../../commons/components/hos/Outro.vue';
import Sfs from '../../commons/components/sfs/Main.vue';

export default {
  components: {
    WebScreen,
    How,
    Why,
    Who,
    Outro,
    Sfs,
  },
};
</script>

<style lang="scss">
#home {
  background: #fff
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="600px" height="600px" viewBox="0 0 100 100"><path d="M5.5 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM6 46a2 2 0 10.001-3.999A2 2 0 006 46zM31.5 8a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 10.001-3.999A2 2 0 0028.5 38zm16-10a2.5 2.5 0 000-5 2.5 2.5 0 000 5zM40 17.5a1 1 0 100-2 1 1 0 000 2zm-10 31a1 1 0 100-2 1 1 0 000 2zm-12.5-25a1 1 0 100-2 1 1 0 000 2zM77.53 24.742a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-21.5-3.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm31.5 15.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-22.5 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-25 3.5a2 2 0 100-4 2 2 0 000 4zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM29.5 74a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM8 70.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM39.5 86a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17 97.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm28-38a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 63a2 2 0 10.001-3.999A2 2 0 0020 63zm23 35.5a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-37-16a1 1 0 100-2 1 1 0 000 2zM77.53 74.242a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-12.5 23.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm14.5-40a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-3 30a2 2 0 100-4 2 2 0 000 4zm14.5 11a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm1.5-21a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-4.5-10.5a1 1 0 100-2 1 1 0 000 2zm-34 15.5a1 1 0 100-2 1 1 0 000 2z" fill="%23e2e8f0" fill-opacity=".3"/></svg>');
  position: relative;
}

#intro {
  filter: drop-shadow(2px 5px 4px rgba(0, 0, 0, .2));
  padding: 1rem 0 3rem;
  position: relative;

  @media (max-width: 480px) {
    max-height: 600px;
  }

  &::before, &::after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &::before {
    background: var(--f-f7);
    -webkit-clip-path: polygon(0 0, 0 100%, 100% 83%,  100% 0);
    clip-path: polygon(0 0, 0 100%, 100% 83%,  100% 0);

    @media (max-width: 768px) {
      -webkit-clip-path: polygon(0 0, 0 100%, 100% 93%,  100% 0);
      clip-path: polygon(0 0, 0 100%, 100% 93%,  100% 0);
    }
  }

  &::after {
    background: var(--f-g5);
    background-image: url(../../public/img/screens/petitions.jpg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    -webkit-clip-path: polygon(0 0,100% 0,100% 100%,0 88%);
    clip-path: polygon(0 0,100% 0,100% 100%,0 88%);
    background-blend-mode: soft-light;
    background-color: color-mix(in srgb, var(--f-g1) 35%, transparent);

    @media (max-width: 768px) {
      -webkit-clip-path: polygon(0 0,100% 0,100% 98%,0 95%);
      clip-path: polygon(0 0,100% 0,100% 98% ,0 95%);
    }
  }

  .container {
    position: relative;
    z-index: 1;
  }

  h1{
    color: var(--f-g9);
    font-size: 5rem;
    font-weight: 400;
    margin: 4rem 0 3rem;

    @media (max-width: 992px) {
      font-size: 4rem;
      margin: 3rem 0 2rem;
    }

    @media (max-width: 768px) {
      font-size: 3rem;
      margin: 2rem 0 1.5rem;
    }
  }

  h2 {
    color: var(--f-g9);
    font-size: 2rem;
    font-weight: 400;
    line-height: 1.25;
    margin: 0;

    @media (max-width: 992px) {
      max-width: 50%;
      font-size: 1.75rem;
    }

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  p {
    color: var(--f-d1);
  }

  .actions {
    display: inline-flex;
    align-items: flex-start;
    margin: 4rem auto 1.5rem;

    @media (max-width: 768px) {
      margin: 3rem auto 1.5rem;
      flex-direction: column;
    }

    .btn {
      margin: .25rem .75rem;
      padding: .75rem 1.25rem;
      text-transform: uppercase;

      @media (max-width: 992px) {
        padding: .5rem 1rem;
      }

      @media (max-width: 768px) {
        margin: .125rem 0;
      }

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .btn-outline-light {
    @media (min-width: 768px) {
      border: transparent;
    }
  }

  #learn-more {
    label {
      color: var(--f-d1);
      background: none;
      text-decoration: none;

      i::before {
        color: var(--f-d1);
      }
    }

    span {
      padding: .25rem ;
      font-size: .875rem;
    }

    input:checked ~ label {
      visibility: hidden;
    }
  }
}

#what {
  padding: 4rem 0;

  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 2rem;

    @media (min-width: 768px) {
      font-size: 3rem;
      line-height: 4rem;
    }
  }

  .card-header {
    border: none;
    background: transparent;
    padding: 0;

    .nav li {
      background: var(--f-g1);
      padding: 0.75rem 1.25rem;
    }
  }

  .card-body .row {
    align-items: center
  }

  h3 {
    font-size: 3rem;
    font-weight: 300;
    letter-spacing: -1px;
    line-height: 1;
    margin: .5rem 0 1rem;

    @media (max-width: 992px) {
      font-size: 2rem;
    }

    @media (max-width: 768px) {
      font-size: 1.75rem;
    }
  }

  p {
    font-size: 1.35rem;
    font-weight: 200;
    line-height: 1.4;

    @media (max-width: 992px) {
      font-size: 1rem;
    }
  }
}

/* SFS */
#support {
  @media (min-width: 992px) { /* cat is hidden by the form below 992px */
    background:
      transparent
      url('../../public/img/gattino-galileo.png')
      no-repeat
      10% calc(100% + 40px);
  }

  .col-lg-7 .ombre {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
}

@media (min-width: 992px) {
  #f-sfs + div { /* #outro parent */
    background:
      transparent
      url('../../public/img/gattino-galileo.png')
      no-repeat
      10% calc(100% + 20px);
  }
}

/* Framanav */
#home #fp-alert {
  background: var(--f-d1);
}

.f-bs4 #f-footer {
  border: none !important;
}
</style>
